<script setup lang="ts">
/**
 * A command in the office status bar's text („Neu berechnen“ while a sheet
 * waits for recalculation): an item-sized button. `tone="warning"` paints it
 * as the pending state it stands for.
 */
import '../office-statusbar.css';

const props = withDefaults(
  defineProps<{
    tone?: 'neutral' | 'warning';
  }>(),
  { tone: 'neutral' }
);
</script>

<template>
  <button
    type="button"
    class="nx-office-statusbar__item nx-office-statusbar__action"
    :class="`nx-office-statusbar__action--${props.tone}`"
  >
    <slot />
  </button>
</template>
